var _circle, _circle2, _path, _ellipse, _ellipse2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#66A3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.8074,
    cy: 25.7474,
    r: 15.2757,
    fill: "#FFF3F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4255 26.6336C12.593 26.1461 15.0907 25.4157 16.4968 24.9816L19.8804 21.2777V24.5066L30.512 24.5066V20.6212C31.3488 21.9993 32.7536 23.6768 33.7181 24.5066C34.2493 24.9635 35.6729 25.488 37.3215 26.0953C38.507 26.5321 39.8089 27.0118 40.9789 27.54C41.0478 26.95 41.0832 26.3499 41.0832 25.7415C41.0832 17.2686 34.2145 10.3999 25.7416 10.3999C17.2687 10.3999 10.4 17.2686 10.4 25.7415C10.4 26.0409 10.4086 26.3384 10.4255 26.6336Z",
    fill: "#6B5555"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5934,
    cy: 28.9079,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0214,
    cy: 28.9079,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9144 32.5947H23.4371C23.4371 33.6482 24.2272 34.4383 25.8074 34.4383C27.2973 34.4383 27.8266 33.2971 27.9144 32.5947Z",
    fill: "#F09387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1038 16.6253C12.8548 17.1232 12.248 17.1699 10.9567 21.3551C16.7509 21.3551 28.8063 21.6742 40.6582 21.4109C40.6582 19.669 38.9759 17.3935 38.5603 16.6415C26.4451 16.3783 18.6346 16.3339 13.1038 16.6253Z",
    fill: "#0074FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile7);
export default __webpack_public_path__ + "static/media/img_profile_7.690ff14f3d360db2c05b22c4e6dfcdf8.svg";
export { ForwardRef as ReactComponent };